export enum OrganizationEndpoint {
  Base = '/organizations',
}
